import moment from 'moment'
import _ from 'lodash'

function showMess (_this, title, mess, icon, toast, time) {
  _this.$bvToast.toast(mess, {
    title: title,
    autoHideDelay: time,
    variant: icon,
    toaster: toast,
    solid: true,
    appendToast: true
  })
}
function formatIntDate (value) {
  if (value) {
    return moment.unix(value).format('DD/MM/YYYY')
  }
}
function formatDateInt (value) {
  if (value) {
    return parseInt(moment(value, 'DD-MM-YYYY').format('X'))
  }
}
function cloneData (value) {
  if (value) {
    return _.cloneDeep(value)
  }
}
function delayShow (value) {
  if (value > 0) {
    return new Promise(resolve => setTimeout(resolve, value))
  } else {
    return new Promise(resolve => setTimeout(resolve, 1000))
  }
}
function validEmail (value) {
  const regex = new RegExp('^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,3})$')
  return regex.test(value)
}
function validPass (value, length = 6) {
  if (value !== '' && length > 0) {
    if (value.length >= length) {
      const regex = new RegExp('^[a-zA-Z0-9_@&#%=~,;\\{\\}\\(\\)\\^\\$\\.\\+\\*\\?\\/\\ ]*$')
      return regex.test(value)
    }
  }
  return false
}
function validMobile (value) {
  const regex = new RegExp('^0[98735]\\d{8,10}$')
  return regex.test(value)
}
function validNameAlias (value) {
  const regex = new RegExp('^[a-zA-Z0-9_\\-@]*$')
  return regex.test(value)
}

export { showMess, formatIntDate, formatDateInt, cloneData, delayShow, validEmail, validPass, validMobile, validNameAlias }
